import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { TruckParameters } from '@services/requests/orderService/types';
import { TransportCountByType } from '@services/requests/routeCalculator/cargoConverterService/SelectCargoParametersQuery';
import React from 'react';

import { FullResultTruck } from './FullResultTruck';
import { ShortResultTruck } from './ShortResultTruck';

type CargoSelectionResultItemTruckProps =
  | {
      outputType: 'full';
      truckParameter: TruckParameters;
      mainLanguage: string;
      BaseData: RouteWidgetBaseParameters;
      truckIndex: number;
    }
  | {
      outputType: 'short';
      truckParameter: TransportCountByType;
      mainLanguage: string;
      BaseData: RouteWidgetBaseParameters;
      truckIndex: number;
    };

function CargoSelectionResultItemTruck({
  truckParameter,
  mainLanguage,
  BaseData,
  truckIndex,
  outputType,
}: CargoSelectionResultItemTruckProps) {
  switch (outputType) {
    case 'full':
      return (
        <FullResultTruck
          BaseData={BaseData}
          truckIndex={truckIndex}
          mainLanguage={mainLanguage}
          truckParameter={truckParameter}
        />
      );
    case 'short':
      return (
        <ShortResultTruck
          BaseData={BaseData}
          truckParameter={truckParameter}
          mainLanguage={mainLanguage}
        />
      );
    default:
      return null;
  }
}

export { CargoSelectionResultItemTruck };
